import { getParameters } from '../../../helpers/helpers';
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../types/types';
import { LINK_CG_TERM_TAX_FORM } from './form-tcg-types';
import { parseTaxInfo } from './form-tcg-helpers';
import { displayTaxes } from '../../widgets/tax-cg-terminal-widget';
import { taxListWidget } from '../../widgets/tax-list-widget';
import { addTaxCardGroupTerminal } from './linlkTaxCardGroupTerminal/add-tax-cardgroup-terminal';
import { ITax } from '../../../models/taxes.interface';

import GetTaxTerminalCardGroup from '../../../routes/get-tax-terminal-cardgroup';

/**
 * links taxes to an individual card group and terminal
 * 
 * @returns void
 */
export const formTaxTerminalCardGroup = async () => {
  if ( !LINK_CG_TERM_TAX_FORM.addCGTaxLink ) return;

  const customerID = getParameters('cID');
  const partnerID = getParameters('pID');
  const terminalID = getParameters('tID');
  const cardGroupID = getParameters('cgID');

  const awsModelData = {
    customerId: +customerID,
    cardgroupId: +cardGroupID,
    partnerId: +partnerID,
    terminalId: terminalID
  }

  const response = await GetTaxTerminalCardGroup(awsModelData);
    
  const { taxes: { linked, avlTax } } = response.body;

  const aTax = avlTax.filter(item => linked.every(item2 => item2.taxId != item.taxId));

  parseTaxInfo(response);
  displayTaxes(linked, LINK_CG_TERM_TAX_FORM.cgTTsearchSelected);
  if ( LINK_CG_TERM_TAX_FORM.cgTTsearchResults ) {
    taxListWidget(aTax, LINK_CG_TERM_TAX_FORM.cgTTsearchResults);
  }
  
  getSelectedTax(LINK_CG_TERM_TAX_FORM.cgTTsearchResults, LINK_CG_TERM_TAX_FORM.cgTTsearchSelected, cardGroupID, terminalID);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}

/**
 * Selects and removes taxes from the available taxes list
 * 
 * @param {HTMLElement} avalContainer the HTML element that has available terminals
 * @param {HTMLElement} resultsContainer the HTML element that has associated terminals
 * @param {string} cardGroupID the cord group id
 * @param {string} terminalID the terminal id
 * @param {string} customerID the customer id
 * 
 * @returns void
 */
const getSelectedTax = (avalContainer: HTMLElement, resultsContainer: HTMLElement, cardGroupID: string, terminalID: string) => {
  avalContainer?.addEventListener('click', e => {
    let data: Array<ITax> = [];
    const target = e.target as HTMLElement;

    if(target != this && target.classList.contains('get-selected-element')) {
      data.push({ taxId: target.dataset.id!, taxName: target.dataset.name!, taxRate: target.dataset.rate! });        
      displayTaxes(data, resultsContainer);
      addTaxCardGroupTerminal(cardGroupID, terminalID);
      target.parentElement!.remove();
    } 
  });
}